import { Icon } from '@iconify/react';
import classnames from "classnames";
import Styles from "./styles.module.scss";
import ellowLogo from "../../assets/images/ellow-logo.svg";
import pageGraphics from "../../assets/images/comingsoon.svg";


function ComingSoon() {



  return (
    <section className={Styles.errorWrap}>
      <img src={ellowLogo} alt="Ellow" className={Styles.logo} />
      <div className={Styles.errorMessage}>
        <img src={pageGraphics}/>
        <h1>Coming Soon!</h1>
        <p> Our Website is almost ready, Stay tuned for something amazing !</p>
      </div>
    </section>
  )
}


export default ComingSoon